module.exports = __webpack_public_path__ + "img/ha@2x.c7d76af7.png";